// extracted by mini-css-extract-plugin
module.exports = {"recapcha":"Login__recapcha__1O_l","TitleSection":"Login__TitleSection__3jhT"};